/**
 * The small navigation pieces every screen shares.
 *
 * `BackLink` is what replaced "Done". A sub-screen names the tab it belongs
 * to — Bank, Wishes, Family — and going back lands there, not on the home
 * screen (back-behavior). It sits where the family-name eyebrow sits on a
 * top-level screen, so the top-left of every screen says either where you
 * are or where you came from.
 *
 * `RowLink` is a tappable row with a chevron, for a list of places to go.
 * It exists because the old pattern — a card with a heading and a bordered
 * "Open" button — made the card look like content and the button look like
 * an action, when the whole thing was a link. Now the whole row is the
 * target and the chevron says so.
 */

import { Link } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from './Icons.jsx';
import './Nav.css';

export function BackLink({ to, children }) {
  return (
    <Link to={to} className="backlink">
      <ChevronLeftIcon size={18} />
      <span>{children}</span>
    </Link>
  );
}

export function RowLink({ to, title, detail, aside, primary = false }) {
  return (
    <Link to={to} className={`rowlink${primary ? ' rowlink--primary' : ''}`}>
      <span className="rowlink__text">
        <span className="rowlink__title">{title}</span>
        {detail && <span className="rowlink__detail">{detail}</span>}
      </span>
      {aside && <span className="rowlink__aside">{aside}</span>}
      <ChevronRightIcon size={20} />
    </Link>
  );
}

/** A group of `RowLink`s with one rule between each. */
export function RowList({ children }) {
  return <div className="rowlist">{children}</div>;
}
